//? Note: jurisdiction specific component

import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import '../../../assets/fontawesome-6.3.0/css/fontawesome.css';
import '../../../assets/fontawesome-6.3.0/css/brands.css';

const Footer = ({ user, config }) => {
    const lotteryBaseUrl = config?.config?.lottery_host ?? 'https://scientificgames.com';
    const lotteryUrl = user?.loggedIn ? `/redirect?url=${lotteryBaseUrl}` : lotteryBaseUrl;
    return (
        <div className='page-footer'>
            <footer>
                <div className='mx-auto text-center'>
                    © 2024. Scientific Games. All rights reserved.
                    <br />
                    <small>
                        <a href={lotteryUrl} rel='noreferrer' target='_blank'>
                            {lotteryBaseUrl}
                        </a>
                    </small>
                </div>
            </footer>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
